import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Creazione di una nuova offerta',
  subtitle: "Come ottiene l'articolo gratuito il cliente?",
  validation: {
    required: 'Seleziona un tipo di offerta',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: "Valore totale dell'ordine",
      description: "Es. 10% di sconto sull'ordine quando spendi 20 {{currency}}",
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Articoli selezionati',
      description: 'Es. 10% di sconto sulle pizze da 12 pollici.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Articoli selezionati',
      description: 'Es. 1 {{currency}} di sconto sulle pizze da 12 pollici.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: "Valore totale dell'ordine",
      description: "Es. 1 {{currency}} di sconto sull'ordine quando spendi 20 {{currency}}",
    },
    [OFFER_KIND.BOGO]: {
      name: 'Compra 1 e prendi 1 gratis',
      description: "Es. Compra 1 pizza e ricevi un'altra pizza gratis. La pizza meno cara è scontata.",
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Compra 1 e prendi 1 a metà prezzo',
      description: "Es. Compra 1 pizza e ricevi un'altra a metà prezzo, la pizza meno cara è scontata.",
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Acquistando un altro articolo',
      description: 'Es. Ricevi una bevanda gratis ordinando un pasto.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Spendendo un importo fisso in {{currency}}',
      description: 'Es. Ricevi un dolce gratis quando spendi 20 {{currency}}.',
    },
  },
};
